import React, { useState } from "react";

import "./Navbar.css";
import { Link, NavLink } from "react-router-dom";

export const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav>
      <Link to="/" className="title">
        Admin Panel
      </Link>
      <div className="menu" onClick={() => setMenuOpen(!menuOpen)}>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <ul className={menuOpen ? "open" : ""}>
      <li>
          <NavLink to="/dashboard">Dashboard</NavLink>
        </li>
        <li>
          <NavLink to="/number">SMS Forwarding</NavLink>
        </li>
        <li>
          {/* <NavLink to="/callnumber">Call Forwarding</NavLink> */}
        </li>
        <li>
          <NavLink to="/showsms">Show SMS</NavLink>
        </li>
        {/* <li>
          <NavLink to="/latest">Latest Data</NavLink>
        </li> */}

        {/* <li>
          <NavLink to="/lastsms">Latest SMS</NavLink>
        </li> */}
        <li>
          <NavLink to="/showdata">Show Data</NavLink>
        </li>
        <li>
          <NavLink to="/profile">Profile</NavLink>
        </li>
      </ul>
    </nav>
  );
};